import React from 'react';

const NoDataFound = ({ message = 'No data found', icon = 'ri-database-2-line', height = '250px' }) => {
  return (
    <div
      style={{
        height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#999',
        textAlign: 'center'
      }}
    >
      <i className={icon} style={{ fontSize: 60, marginBottom: 12 }} />
      <div style={{ fontSize: 18 }}>{message}</div>
    </div>
  );
};

export default NoDataFound;